import React, { Component } from 'react';
import styleBinder from 'classnames/bind';
import styles from './icon.module.css';

// eslint-disable-next-line no-restricted-syntax -- TODO: legacy class component (baseline)
export default class Icon extends Component {
    render() {
        const { className, wrapped = true, type, size, pulse, ...rest } = this.props;
        const cx = styleBinder.bind(styles);
        const iconStyle = cx(className, { icon: true, [type]: true, [`size-${size}x`]: !!size, pulse });

        //todo wrapped flag is hotfix, need more clean solution
        return wrapped ? (
            // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
            <div className={styles.wrapper} {...rest}>
                <i className={iconStyle} />
            </div>
        ) : (
            // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
            <i className={iconStyle} {...rest} />
        );
    }
}
